<template>
  <label>連絡事項がある場合、記入のうえ送信してください</label>  
  <textarea v-model="editingNotes" rows="5" :disabled="isLoading" :class="{ error: honninError }" :placeholder="'連絡事項を記入（任意）'" ></textarea>
  <p class="input-error" v-if="honninError" style="margin-bottom: 10px;">{{ honninError }}</p>
  <template v-if="isLoading">
    <loading :isLoading="isLoading" :message="'処理中...'"></loading>
  </template>
  <div v-else class="buttons vertical">
    <button type="button" class="btn success" @click="send()"><i class="fa-solid fa-inbox"></i>備考の送信</button>
    <button type="button" class="btn cancel" @click="cancel()"><i class="fa-solid fa-x"></i>閉じる</button>
  </div>
</template>


<script lang="ts">
import { useDakoku } from '@/composable/dakoku/dakoku'
import { defineComponent, ref, computed, Ref } from 'vue'
import { useForm } from '@/composable/form/form'
import { boolRes } from '@/types/Dakoku'

export default defineComponent({
  props: {
    koyouKeiyakuId: {
      type: Number,
      require: true,
      default: null
    },
    syuugyouBasyoId: {
      type: Number,
      require: true,
      default: null
    },
    targetDate: {
      type: Object as () => string | Date | null,
      require: true,
      default: null
    },
    notes: {
      type: Object as () => string | null,
      require: true,
      default: null
    },
    koyouKeiyakuTimeId: {
      type: Object as () => number | null,
      require: true,
      default: null
    },
  },
  emits: {
    cancel() {
      return true
    },
    send() {
      return true
    }
  },
  setup(props, context) {
    const { honninNotes, isLoading } = useDakoku()
    const { getError } = useForm()
    const editingNotes = ref(props.notes ? props.notes : '');
    const resultForm:Ref<boolRes> = ref({ result: false })
    const honninError = computed(() => {
      return getError(resultForm.value, 'honninNotes')
    })
    const cancel = () => {
      context.emit('cancel')
    }

    const send = async () => {
      if (!props.targetDate) {
        return
      }

      try {
        let res = await honninNotes(props.targetDate, editingNotes.value, props.syuugyouBasyoId, props.koyouKeiyakuId, props.koyouKeiyakuTimeId);

        if(res.result){
          context.emit('send');
        }else{
          resultForm.value = res
        }
      } catch (e) {
        console.error(e);
      }
    }


    return {
      cancel,
      send,
      editingNotes,
      isLoading,
      getError,
      honninError,
    }
  }
})
</script>
